import { useEffect, forwardRef } from 'react'
import { AvmHistory } from '../../../../types/homePreview'
import ValueLineChart from '../../../../charts/ValueLineChart'
import { Box, Card, Text, useTheme } from '@homebotapp/hb-react-component-catalog'

import styles from './Chart.module.scss'

const ESTIMATED_VALUE_CHART_ID = 'estimated-value-chart'

interface ValueLineChartWrapperProps {
  data: AvmHistory | null
}

export const ValueLineChartWrapper = forwardRef<SVGSVGElement | null, ValueLineChartWrapperProps>(({ data }, ref) => {
  const { theme } = useTheme()

  useEffect(() => {
    const chart = new ValueLineChart(document.getElementById(ESTIMATED_VALUE_CHART_ID), theme)

    chart.update(data)

    return () => chart.destroy()
  }, [theme, data])

  return (
    <>
      <svg ref={ref} className={styles.chart} id={ESTIMATED_VALUE_CHART_ID} data-qa='estimated-value-chart' />
      <Box id='tooltip' position='absolute'>
        <Card padding={2}>
          <Text size='2xs' margin={0} className='avm' fontWeight='semibold' />
          <Text size='2xs' margin={0} color='brand' className='date' fontWeight='semibold' />
        </Card>
        {/*
        These nested boxes create 2 triangles (arrow facing down).
        The outside triangle acts as a border for the inside one.jq
      */}
        <Box
          width={0}
          position='relative'
          margin='-0.0625rem auto 0.5rem auto'
          borderLeft='.5625rem solid transparent'
          borderRight='.5625rem solid transparent'
          borderTop={`.5625rem solid var(--hb-colors-${theme.isLightThemeType ? 'blackAlpha-200' : 'whiteAlpha-200'})`}
        >
          <Box
            width={0}
            right={0}
            zIndex={1}
            bottom='0.0625rem'
            position='absolute'
            transform='translateX(50%)'
            borderLeft='.5rem solid transparent'
            borderRight='.5rem solid transparent'
            borderTop={`.5rem solid var(--hb-colors-card-bg-layer-2)`}
          />
        </Box>
      </Box>
    </>
  )
})
